<!--<router-outlet></router-outlet>-->
<div class="card-list">
    <ispm-pathways-panel *ngIf="!verticalLeftContainerPatientView" class="ispm-left-panel"></ispm-pathways-panel>
    <ispm-bpmn-viewer *ngIf="!isPathwayActive"
                      class="ispm-viewer display-block"
                      [hideBpmnLogo]="hideBpmnLogo"
                      [isVerticalMode]="verticalLeftContainerPatientView"></ispm-bpmn-viewer>

        <div class="select-pathway-container" *ngIf="isPathwayActive">
            <div class="select-pathway-bar">
                <div *ngIf="selectPathwayTitle" class="select-pathway-title">{{selectPathwayTitle}}</div>
                <div class="select-pathway-action-buttons">
                    <gen-step-confirmation-button *ngIf="isSelectPathwayBarEnabled"
                                                  [currentRevision]="currentRevision"
                                                  [currentWorkflow]="currentWorkflow"
                                                  [disableIfNotActive]="true"
                                                  [type]="'primary'"
                                                  class="step-confirmation-button">
                    </gen-step-confirmation-button>
                </div>
             </div>
           
             <ispm-bpmn-execution
            class="ispm-viewer display-block"
            [hideBpmnLogo]="hideBpmnLogo"
            [isVerticalMode]="verticalLeftContainerPatientView"></ispm-bpmn-execution>
        </div>
</div>